import React from "react";
import cnpj from "../../assets/image/principal/png/NuvemFiscalCNPJ.png";
import ZoomImage from "../../components/ZoomImage";
import "./CardContent.scss";

const Cte = ({ className, ...rest }) => {
  return (
    <div className={`card-section `} {...rest} id="cte">
      <div className="container container-section">
        {/* Section Title */}
        <ZoomImage src={cnpj} alt=""/>
        <div
          data-aos="fade-right"
          data-aos-delay={500}
          className="text-content"
        >
          <h2  style={{color: "rgb(250, 128, 114)"}}>
            CT-e
          </h2>
          <br/>
            <p className="text-section">
            Com a Nuvem Fiscal, seu sistema pode emitir, consultar e gerenciar documentos CT-e - Conhecimento de Transporte Eletrônico.
            </p>
            <br/>
              <div className="btn-group d-inline-block mt-10">
              <a className="btn btn-2 rounded-5" style={{backgroundColor: "rgb(250, 128, 114)", color: "white"}} href={"https://dev.nuvemfiscal.com.br/docs/cte"}>
                 Saiba mais
              </a>
              </div>
            </div>
      </div>
    </div>
  );
};

export default Cte;
